Application.Postcard.Background = {
    ui: {
        container: '.js-postcard-background',
        previewContent: '.js-postcard-background__preview-content',
        inputRotation: '.js-postcard-background__input-rotation'
    },
    previewList: null,
    rotation: null,
    ready: function (previewList) {

        var self = this;

        if (!$(this.ui.container).length){
            return;
        }

        // assign
        this.previewList = previewList;

        // children
        // this.rotation = parseInt($(this.ui.inputRotation).val());
        // this.Transformer.ready(this);
        // this.Transformer.setRotation(this.rotation);

        // bind handlers
        this.bind();

    },
    bind: function(){

        var self = this;

        // update logo position when ready
        // update background when requested
        this.previewList.setOnChange(function(id, src, data){
            // change background
            self.background(id, src);
        });

        // transformer
        // this.Transformer.on('rotate', function(angle){
        //     self.rotate(angle);
        // });

    },
    background: function(id, src, onloaded){

        var self = this;

        // load the image
        $('<img/>').attr('src', src).on('load', function() {
            // prevent memory leaks
            $(this).remove();
            // change background
            $(self.ui.previewContent).css('background-image', 'url(' + src + ')');
            // loaded callback
            if (typeof onloaded == 'function') {
                onloaded();
            }
        });

    },
    rotate: function(angle){

        // update input settings
        this.rotation = angle;
        this.updateInput();

    },
    updateInput: function(){

        $(this.ui.inputRotation).val(this.rotation);

    }
};